module.exports = __webpack_public_path__ + "img/Coin BankB02.e07861fa.png";